<div class="container-fluid">
	<div class="row flex-nowrap">

		<div id="menu-panel" class="col-auto d-none d-md-block">

			<div class="menu-header text-center">
				<i class="fa fa-4x fa-briefcase page-icon"></i>
			</div>

			<div>
				<button id="filter-btn" class="btn btn-dark pl-3 pr-3 mb-2" onclick="Anvil.page.searchModal()"><i class="fa fa-lg mb-2 fa-filter"></i><br />Szűrő<span id="filter-btn-badge" class="badge rounded-pill bg-danger ms-1 d-none"></span></button><br />
				<button class="btn btn-primary pl-3 pr-3" onclick="Anvil.page.refresh()"><i class="fa fa-lg mb-2 fa-sync-alt"></i><br />Frissítés</button>
				<!--
				<hr />
				<div class="text-center">ADATOK</div>
				<div class="btn-group-vertical">
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-import"></i><br />Importálás</button>
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-export"></i><br />Exportálás</button>
				</div>
				-->
			</div>
		</div>

		<div class="col list-panel">

			<div class="row">
				<div class="col">

					<div class="page-header">

						<ol class="breadcrumb mb-2">
							<li class="breadcrumb-item"><a href="/home"><i class="fa fa-home"></i></a></li>
							<li class="breadcrumb-item active">Feladatkezelő</li>
						</ol>

						<div class="float-end">
							<div class="row g-2">
								<div class="col-auto d-none d-lg-block" style="width:190px;">
									<%- include('/ui/form', {
										params: [ 'search_1', search ],
										fields: [
											{
												type: 'select',
												inline: true,
												name: 'closed',
												title: 'Státusz',
												params: {
													maxItems: 1,
													options: [
														{ value: 0, label: 'Nyitott', icon: 'lock-open', color: 'text-warning' },
														{ value: 1, label: 'Lezárt', icon: 'lock', color: 'text-success' }
													],
													valueField: 'value',
													labelField: 'label',
													render: {
														item: (item, esc) => `<div><i class="fa fa-fw fa-${item.icon} me-2 ${item.color}"></i>${esc(item.label)}</div>`,
														option: (item, esc) => `<div class="option"><i class="fa fa-fw fa-${item.icon} me-2 ${item.color}"></i>${esc(item.label)}</div>`
													},
													placeholder: '[ minden státusz ]'
												},
												append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.closed = null;"><i class="fa fa-fw fa-times"></i></button>',
												update: (value) => {
													Anvil.page.quickSearch()
												}
											}
										]
									}) %>
								</div>
								<div class="col d-none d-lg-block" style="width:380px;">
									<%- include('/ui/form', {
										params: [ 'search_2', search ],
										fields: [
											{
												type: 'select',
												inline: true,
												name: 'worker_user_id',
												title: 'Résztvevő',
												params: {
													maxItems: 1,
													options: [ { id: -1, account_name: '[ résztvevő nélkül ]' }, ...users.data.filter(u => u.active) ],
													valueField: 'id',
													labelField: 'account_name',
													searchField: [ 'account_name' ],
													render: {
														item: (item, esc) => `<div>${esc(item.account_name)}</div>`,
														option: (item, esc) => `<div class="option">${esc(item.account_name)}</div>`
													},
													placeholder: '[ minden felhasználó ]'
												},
												unset_value: null,
												prepend: '<span class="input-group-text"><i class="fa fa-user"></i></span>',
												append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.worker_user_id = null;"><i class="fa fa-fw fa-times"></i></button>',
												update: (value) => {
													Anvil.page.quickSearch()
												}
											}
										]
									}) %>
								</div>
								<div class="col-auto" style="width:300px; max-width:50vw;">
									<%- include('/ui/form', {
										params: [ 'search', search ],
										fields: [
											{
												type: 'text',
												inline: true,
												name: 'expression',
												title: 'Szöveges keresés',
												attributes: {
													placeholder: 'Keresés...'
												},
												append: '<span class="input-group-text"><i class="fa fa-search"></i></span>',
												update: (value) => {
													Anvil.page.quickSearch()
												}
											}
										]
									}) %>
								</div>
								<div class="col-auto d-lg-none">
									<button id="filter-btn-2" class="btn btn-dark position-relative" onclick="Anvil.page.searchModal()"><i class="fa fa-fw fa-filter"></i><span id="filter-btn-badge-2" class="badge rounded-pill bg-danger position-absolute top-0 start-100 translate-middle d-none"></span></button>
								</div>
							</div>
						</div>
						<h2 class="pt-1">Feladatkezelő</h2>
					</div>

					<%- include('/ui/grid', {
						name: 'issue',
						params: {
							row_height: 28.5,
							columns: [
								{
									title: 'Hozzáadva',
									field: 'insert_dt',
									type: 'datetime',
									width: 150
								},
								{
									title: 'P.',
									field: 'priority_tag',
									type: {
										render (value, row, data, params) {

											if (!value) return ''

											const tag = Anvil.page.issue_tags.getById(value)
											if (tag.type != 'priority') return undefined
											if (tag.icon) {
												return `<span class="badge text-dark" title="${tag.name}" style="background-color:${row.closed ? 'transparent' : tag.color};"><i class="${tag.icon} fa-fw"></i></span>`
											} else {
												return `<span class="badge text-dark" style="background-color:${row.closed ? 'transparent' : tag.color};">${tag.name}</span>`
											}
										}
									},
									options: {
										class: 'text-center'
									},
									width: 50
								},
								{
									title: 'T.',
									field: 'work_tags',
									type: {
										render (value, row, data, params) {

											// Tags
											let tags_html = ''
											if (Array.isArray(row.work_tags)) {
												tags_html = row.work_tags.map(tid => {
													const tag = Anvil.page.issue_tags.getById(tid)
													if (tag.type != 'work') return undefined
													if (tag.icon) {
														return `<span class="badge text-dark" title="${tag.name}" style="background-color:${tag.color};"><i class="${tag.icon} fa-fw"></i></span>`
													} else {
														return `<span class="badge text-dark" style="background-color:${tag.color};">${tag.name}</span>`
													}
												}).filter(Boolean).join(' ')
											}

											return tags_html
										}
									},
									options: {
										class: 'text-center'
									},
									width: 60
								},
								{
									title: 'Téma',
									field: 'title',
									type: {
										render (value, row, data, params) {

											// Tags
											let tags_html = ''
											if (Array.isArray(row.tags) && row.tags.length > 0) {
												tags_html = row.tags.map(tid => {
													const tag = Anvil.page.issue_tags.getById(tid)
													if (tag.type != 'project') return undefined
													if (tag.icon) {
														return `<span class="badge text-dark" title="${tag.name}" style="background-color:${tag.color};"><i class="${tag.icon} fa-fw"></i></span>`
													} else {
														return `<span class="badge text-dark" style="background-color:${tag.color};">${tag.name}</span>`
													}
												}).filter(Boolean).join(' ')
											}

											if (row.closed) {
												return `${tags_html} <span class="text-success">${value}</span>`
											} else if (row.responsible_user_id == Anvil.session.user.id) {
												return `${tags_html} <strong>${value}</strong>`
											} else {
												return `${tags_html} <span>${value}</span>`
											}
										}
									},
									width: 500
								},
								{
									title: 'L.',
									field: 'user_view_dt',
									type: {
										render (value, row, data, params) {
											const issue_updated_dt = row.update_dt || row.insert_dt
											if (row.user_view_dt && Anvil.moment(row.user_view_dt).isSameOrAfter(issue_updated_dt)) {
												// Seen
												return ''
											} else {
												// Unseen
												return '<i class="fas fa-fw fa-star text-gold"></i>'
											}
										}
									},
									options: {
										class: 'text-center'
									},
									width: 50
								},
								{
									title: 'S.',
									field: 'closed',
									type: {
										render (value, row, data, params) {
											if (value == '1') {
												// Closed
												return '<span class="badge bg-dark text-success"><i class="fa fa-fw fa-lock"></i></span>'
											} else {
												// Open
												return '<span class="badge bg-dark text-dim"><i class="fas fa-fw fa-lock-open"></i></span>'
											}
										}
									},
									options: {
										class: 'text-center'
									},
									width: 50
								},
								{
									title: 'Felelős',
									field: 'responsible_user_id',
									type: {
										render (value, row, data, params) {
											let user = Anvil.page.users.data.find(u => u.id == value)
											if (user) {
												if (user.id == Anvil.session.user.id) {
													return `<span class="text-primary"><i class="fa fa-fw fa-sm fa-user me-2"></i>${user.account_name}</span>`
												} else {
													return `<span><i class="fa fa-fw fa-sm fa-user me-2"></i>${user.account_name}</span>`
												}
											} else {
												return '<span class="text-muted"><i class="fa fa-fw fa-sm fa-user me-2"></i>Nincs</span>'
											}
										}
									},
									width: 180
								},
								{
									title: 'Társított entitás',
									field: 'link',
									value: (v, row) => {
										let entity_chain = []
										if (['company', 'database', 'site', 'terminal', 'aee'].includes(v)) {
											const company = Anvil.page.companies.data.find(c => c.id == row.company_id)
											entity_chain.push(company.name)
											if (['database', 'site', 'terminal', 'aee'].includes(v)) {
												const company_db = Anvil.page.company_dbs.data.find(c => c.id == row.company_db_id)
												entity_chain.push(company_db.db_name)
												if (['site', 'terminal', 'aee'].includes(v)) {
													const site = Anvil.page.sites.data.find(s => s.company_db_id == row.company_db_id && s.id == row.site_id)
													entity_chain.push(site.public_name || site.name)
													if (['terminal', 'aee'].includes(v)) {
														const terminal = Anvil.page.terminals.data.find(t => t.machine_id == row.terminal_id)
														entity_chain.push(terminal.device_info?.hostname || undefined)
														if (['aee'].includes(v)) {
															const aee = Anvil.page.aees.data.find(a => a.id == row.aee_id)
															entity_chain.push(aee.ap)
														}
													}
												}
											}

											return entity_chain.filter(Boolean).join(' ')
										}
									},
									type: {
										render (value, row, data, params) {
											let entity_chain = []

											if (['company', 'database', 'site', 'terminal', 'aee'].includes(row.link)) {
												const company = Anvil.page.companies.data.find(c => c.id == row.company_id)
												entity_chain.push(`<div class="link-entity" onclick="Anvil.exec('company/modal_edit', ${row.company_id})"><i class="fa fa-fw fa-sm fa-building me-1"></i>` + (company?.name || '[ismeretlen cég]') + '</div>')
												if (['database', 'site', 'terminal', 'aee'].includes(row.link)) {
													const company_db = Anvil.page.company_dbs.data.find(c => c.id == row.company_db_id)
													entity_chain.push(`<div class="link-entity" onclick="Anvil.exec('c_order/company_db/modal_edit', ${row.company_db_id})"><i class="fa fa-fw fa-sm fa-database me-1"></i>` + (company_db?.db_name || '[ismeretlen adatbázis]') + '</div>')
													if (['site', 'terminal', 'aee'].includes(row.link)) {
														const site = Anvil.page.sites.data.find(s => s.company_db_id == row.company_db_id && s.id == row.site_id)
														entity_chain.push(`<div class="link-entity" onclick="Anvil.exec('c_order/site/modal_edit', ${row.company_db_id}, ${row.site_id})"><i class="fa fa-fw fa-sm fa-map-marker me-1"></i>` + (site?.public_name || site?.name || '[ismeretlen telephely]') + '</div>')
														if (['terminal', 'aee'].includes(row.link)) {
															const terminal = Anvil.page.terminals.data.find(t => t.machine_id == row.terminal_id)
															entity_chain.push(`<div class="link-entity" onclick="Anvil.exec('c_order/terminal/modal_edit', ${row.company_id}, '${row.terminal_id}')"><i class="fa fa-fw fa-sm fa-desktop me-1"></i>` + (terminal?.device_info?.hostname || '[ismeretlen terminál]') + '</div>')
															if (['aee'].includes(row.link)) {
																const aee = Anvil.page.aees.data.find(a => a.id == row.aee_id)
																entity_chain.push(`<div class="link-entity" onclick="Anvil.exec('c_order/aee/modal_edit', ${row.aee_id})"><i class="fa fa-fw fa-sm fa-cash-register me-1"></i>` + (aee?.ap || '[ismeretlen pénztárgép]') + '</div>')
															}
														}
													}
												}
											} else {
												entity_chain.push('<span class="text-muted">Nincs</span>')
											}

											return entity_chain.join('<span style="color:black;"><i class="fa fa-fw fa-sm fa-caret-right"></i></span>')
										}
									},
									width: 750
								}
							]
						},
						list: issues
					}) %>
				</div>
			</div>

			<div class="py-3">
				<button onclick="history.back()" class="btn btn-dark"><i class="fa fa-angle-left me-2"></i>Vissza</button>
				<div class="float-end">
					<button class="btn btn-success" onclick="Anvil.page.new()"><i class="fa fa-fw fa-plus"></i><span class="d-none d-md-inline ms-2">Új munkalap</span></button>
					<button class="btn btn-primary ml-2" onclick="Anvil.page.open()"><i class="fa fa-fw fa-edit"></i><span class="d-none d-md-inline ms-2">Megnyitás</span></button>
					<button class="btn btn-danger ml-2" onclick="Anvil.page.delete()"><i class="fa fa-fw fa-trash"></i><span class="d-none d-md-inline ms-2">Törlés</span></button>
				</div>
			</div>

		</div>

	</div>
</div>

<script>
Object.assign(Anvil.page, {

	init () {
		Anvil.page.quickSearch()
	},

	searchModal () {
		Anvil.modal('/issue/page_list_search_modal', { search: Anvil.page.search })
	},

	quickSearch () {
		const filters = []
		const params = {
			sort_order: Anvil.page.search.sort_order
		}
		if (Anvil.page.search.closed) {
			if (Anvil.page.search.closed === '0' || Anvil.page.search.closed === '1') {
				filters.push(row => row.closed == parseInt(Anvil.page.search.closed))
				params.closed = Anvil.page.search.closed
			}
		}
		if (Anvil.page.search.responsible_user_id) {
			if (Anvil.page.search.responsible_user_id == -1) {
				filters.push(row => row.responsible_user_id === null)
				params.responsible_user_id = null
			} else {
				filters.push(row => row.responsible_user_id == Anvil.page.search.responsible_user_id)
				params.responsible_user_id = Anvil.page.search.responsible_user_id
			}
		}
		if (Anvil.page.search.worker_user_id) {
			if (Anvil.page.search.worker_user_id == -1) {
				filters.push(row => (row.worker_user_ids === null || (Array.isArray(row.worker_user_ids) && row.worker_user_ids.length === 0)) && row.responsible_user_id === null)
				params.worker_user_id = null
			} else {
				filters.push(row => (Array.isArray(row.worker_user_ids) && row.worker_user_ids.includes(Anvil.page.search.worker_user_id)) || row.responsible_user_id == Anvil.page.search.worker_user_id)
				params.worker_user_id = Anvil.page.search.worker_user_id
			}
		}
		if (Anvil.page.search.work_tag_id) {
			if (Anvil.page.search.work_tag_id == -1) {
				filters.push(row => row.work_tags === null || (Array.isArray(row.work_tags) && row.work_tags.length === 0))
				params.work_tag_id = null
			} else {
				filters.push(row => Array.isArray(row.work_tags) && row.work_tags.includes(Anvil.page.search.work_tag_id))
				params.work_tag_id = Anvil.page.search.work_tag_id
			}
		}

		const expression = Anvil.page.search.expression
		if (expression) {
			params.expression = expression
		}

		if (filters.length > 0) {
			$('#filter-btn, #filter-btn-2').removeClass('btn-dark').addClass('btn-success')
			$('#filter-btn-badge, #filter-btn-badge-2').text(filters.length).removeClass('d-none')
		} else {
			$('#filter-btn, #filter-btn-2').removeClass('btn-success').addClass('btn-dark')
			$('#filter-btn-badge, #filter-btn-badge-2').text('').addClass('d-none')
		}

		// Generate URL
		window.history.replaceState({}, '', Anvil.href('/issue/list', params))

		Anvil.models.components.Grid.find('#issue_grid').filter(expression, filters)
	},

	refresh () {
		Anvil.exec('issue/action_refresh')
	},

	new () {
		Anvil.exec('issue/modal_edit')
	},

	open () {
		let sel = Anvil.models.components.Grid.find('#issue_grid').selected_rows
		if (sel.length > 0) {
			Anvil.exec('issue/modal_edit', sel[0].id)
		}
	},

	delete () {
		let sel = Anvil.models.components.Grid.find('#issue_grid').selected_rows
		if (sel.length > 0) {
			Anvil.exec('issue/action_delete', sel[0].id)
		}
	}
})

$('#issue_grid').on('dblclick', 'tbody tr', function () {
	Anvil.page.open()
})
</script>
